import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { TASK_DATA } from '../../../core/contracts/task-data.contract';
import { Task, TaskType } from '../../../core/models/task.interface';

@Component({
  selector: 'tasks-process-guarantee-application-task-details',
  standalone: true,
  templateUrl: './process-guarantee-application-task-details.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProcessGuaranteeApplicationTaskDetailsComponent {
  protected readonly task = inject<Task<TaskType.ProcessGuaranteeApplication>>(TASK_DATA);
}
